module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 100
    }
  }, [(_vm.isError) ? _c('Back', {
    on: {
      "back": _vm.back
    }
  }, [_c('Infotext', {
    attrs: {
      "text": _vm.errorMessage
    }
  })], 1) : [_c('Header', [_vm._v("История откликов")]), _c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.selectItems), function(item) {
    return _c('div', {
      key: item.value,
      staticClass: "tab",
      class: {
        selected: _vm.isActivitiesInUse === item.value
      },
      on: {
        "click": function($event) {
          _vm.isActivitiesInUse = item.value
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 0), (_vm.hasFeedbacks) ? [_c('List', {
    attrs: {
      "items": _vm.items
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c(_vm.component, {
          key: item.id,
          tag: "component",
          attrs: {
            "item": item
          },
          on: {
            "cancel": _vm.cancel
          }
        })]
      }
    }], null, false, 2578779638)
  })] : _c('Warning', [_c('p', [_vm._v("У вас нет ни одного отклика.\nОткликнувшись на вакансию в разделе «Вакансии» здесь будет информация вакансиях на которые вы откликнулись.")])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c861d04","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/vacancy/Vacancy.vue
// module id = 0d1bb50aaa1225c031a6
// module chunks = 53